import React from 'react';
import { Dialog } from '@mui/material';
import AButton from '../../../../common/form-fields-mui/AButton';
import AInput from '../../../../common/formFeilds/customInput/AInput';
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg"
import styles from "./styles.module.scss";

const TicketFormDialog = ({ form, handleForm, handleClose }) => {

    return (
        <Dialog open={form?.isTicketFormOpen}>
            <div className='m-2 p-2'>

                <span className={styles['ticket-form-dialog-header']}>Enter ticket number to make changes</span>
                <CrossIcon style={{ marginTop: '3px' }} onClick={handleClose} className='ml-4 float-right cursor' />

                <AInput
                    label="Ticket number"
                    labelStyle={{ fontWeight: 600, fontSize: '12px' }}
                    style={{ height: '42px' }}
                    placeholder="Enter ticket no"
                    value={form?.ticketNo}
                    handler={(val) => handleForm(val, "ticketNo")}
                />

                <AButton
                    variant="primary_filled"
                    className='no-ml-btn mt-2'
                    disabled={!form?.ticketNo?.trim()}
                    onClick={() => handleForm(false, "isTicketFormOpen")}
                >
                    Save
                </AButton>

            </div>
        </Dialog>

    );
}

export default TicketFormDialog;